import { OTPInput, REGEXP_ONLY_DIGITS } from "input-otp";

function Slot({ char, isActive, hasFakeCaret }) {
  return (
    <div
      className={`relative flex h-14 w-11 items-center justify-center rounded-lg border-2 bg-graphite-950 font-mono text-xl font-bold text-electric transition-[border-color,box-shadow] duration-150 sm:w-12 ${
        isActive ? "border-electric shadow-[0_0_0_3px_rgba(0,242,253,0.18)]" : "border-white/15"
      }`}
    >
      {char}
      {hasFakeCaret ? <span className="absolute h-6 w-px animate-pulse bg-electric" /> : null}
    </div>
  );
}

export function OtpInput({ value, onChange, onComplete, disabled, testId, autoFocus = true }) {
  return (
    <OTPInput
      maxLength={6}
      value={value}
      onChange={onChange}
      onComplete={onComplete}
      disabled={disabled}
      autoFocus={autoFocus}
      pattern={REGEXP_ONLY_DIGITS}
      inputMode="numeric"
      autoComplete="one-time-code"
      data-testid={testId}
      containerClassName="flex items-center gap-2 has-[:disabled]:opacity-50"
      render={({ slots }) => (
        <div className="flex items-center gap-2">
          {slots.slice(0, 3).map((slot, i) => (
            <Slot key={i} {...slot} />
          ))}
          <span className="mx-1 h-px w-3 bg-white/20" />
          {slots.slice(3).map((slot, i) => (
            <Slot key={i + 3} {...slot} />
          ))}
        </div>
      )}
    />
  );
}
